"use client";

import { DebugInfoSectionProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/DebugInfo/DebugInfoSectionProps";
import { LazyDebugInfoSection } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/DebugInfo/LazyDebugInfoSection";
import { getUser } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getUser";
import React, { Suspense } from "react";

export const DebugInfoSection = ({
  data: { productToken, promotedBy, debugInfo },
}: {
  data: DebugInfoSectionProps;
}) => {
  // TODO: change to useUserStore when QueryClient is added to perf app
  const user = getUser();
  const isEmployee = !!user?.is_employee;
  const isImpersonating = !!user?.impersonating;

  if (!productToken) {
    return null;
  }
  if (!(isEmployee || isImpersonating)) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <LazyDebugInfoSection
        productToken={productToken}
        promotedBy={promotedBy}
        debugInfo={debugInfo}
      />
    </Suspense>
  );
};
